import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=a090d9d2&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=a090d9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a090d9d2",
  null
  
)

export default component.exports